<template>
  <div class="FaqDetails">
    <app-link to="/faq" back label="Вернуться к списку вопросов" />
    <h2 class="FaqDetails__title">{{ response.question }}</h2>
    <p v-text="response.answer" class="FaqDetails__content"></p>
    <div v-if="response.content.length" class="FaqDetails__additional-content">
      <template v-for="item in response.content">
        <p
          v-if="item.type === 'text'"
          :key="item.value + item.type"
          class="FaqDetails__content"
          v-text="item.value"
        ></p>
        <div
          v-if="item.type === 'image'"
          :key="item.value + item.type"
          class="FaqDetails__image-wrapper"
        >
          <img :src="item.value" :alt="item.type" class="FaqDetails__image" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaqDetails',
  components: {
    AppLink: () => import('@/components/ui/AppLink'),
  },
  props: {
    response: {
      type: Object,
      require: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.FaqDetails {
  padding: 20px;
  background-color: $color-white;
  border-radius: 2px;
  box-shadow: $box-shadow-card-1;

  &__image-wrapper {
    display: flex;
    max-width: 100%;
    margin-bottom: 10px;
  }

  &__image {
    display: block;
    max-width: 100%;
    height: auto;
    margin: auto;
  }

  &__title {
    @include h-reset;

    margin-top: 17px;
    margin-bottom: 22px;
    font-size: rem(18);
    font-weight: 300;
    line-height: 20px;
    color: $black;
  }

  &__content {
    display: flex;
    margin-top: 0;
    margin-bottom: 10px;
    font-size: rem(14);
    font-weight: 100;
    line-height: 20px;
    word-break: break-word;
    white-space: pre-wrap;
  }
}
</style>
